import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';

// ⚠️ Même remarque que MotDePasseOublie.js : vérifie le chemin d'import de `api` (ligne 3).

const ReinitialiserMotDePasse = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [show, setShow] = useState(false);
    const [erreur, setErreur] = useState('');
    const [succes, setSucces] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErreur('');

        if (!token) {
            setErreur('Lien invalide. Veuillez refaire une demande de réinitialisation.');
            return;
        }
        if (password.length < 6) {
            setErreur('Le mot de passe doit contenir au moins 6 caractères.');
            return;
        }
        if (password !== confirm) {
            setErreur('Les deux mots de passe ne correspondent pas.');
            return;
        }

        setLoading(true);
        try {
            await api.post('/auth/reset-password', { token, password });
            setSucces(true);
            setTimeout(() => navigate('/login'), 2500);
        } catch (err) {
            const msg = err?.response?.data?.message || "Une erreur est survenue. Veuillez réessayer.";
            setErreur(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <h1 style={styles.title}>Nouveau mot de passe</h1>

                {succes ? (
                    <p style={styles.success}>
                        Votre mot de passe a été réinitialisé avec succès.
                        Redirection vers la connexion...
                    </p>
                ) : !token ? (
                    <>
                        <div style={styles.error}>
                            Lien invalide ou incomplet. Veuillez refaire une demande.
                        </div>
                        <p style={styles.backLink}>
                            <Link to="/mot-de-passe-oublie" style={styles.link}>Refaire une demande</Link>
                        </p>
                    </>
                ) : (
                    <>
                        <p style={styles.subtitle}>Choisissez votre nouveau mot de passe.</p>

                        {erreur && <div style={styles.error}>{erreur}</div>}

                        <form onSubmit={handleSubmit}>
                            <label style={styles.label}>Nouveau mot de passe</label>
                            <div style={styles.inputWrap}>
                                <FaLock style={styles.inputIcon} />
                                <input
                                    type={show ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Au moins 6 caractères"
                                    required
                                    style={styles.input}
                                />
                                <span onClick={() => setShow(!show)} style={styles.eye}>
                                    {show ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>

                            <label style={styles.label}>Confirmer le mot de passe</label>
                            <div style={styles.inputWrap}>
                                <FaLock style={styles.inputIcon} />
                                <input
                                    type={show ? 'text' : 'password'}
                                    value={confirm}
                                    onChange={(e) => setConfirm(e.target.value)}
                                    placeholder="Retapez le mot de passe"
                                    required
                                    style={styles.input}
                                />
                            </div>

                            <button type="submit" disabled={loading} style={styles.button}>
                                {loading ? 'Enregistrement...' : 'Réinitialiser'}
                            </button>
                        </form>

                        <p style={styles.backLink}>
                            <Link to="/login" style={styles.link}>← Retour à la connexion</Link>
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

const styles = {
    page: {
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #fdf2f8 0%, #fce4ef 100%)', padding: '20px',
        fontFamily: 'Arial, sans-serif',
    },
    card: {
        background: '#fff', borderRadius: '20px', padding: '40px 32px',
        boxShadow: '0 8px 30px rgba(120,24,64,0.12)', maxWidth: '420px', width: '100%',
    },
    title: {
        color: '#781840', fontSize: '26px', fontWeight: '700', margin: '0 0 12px', textAlign: 'center',
        fontFamily: 'Cormorant Garamond, serif',
    },
    subtitle: { color: '#7a6570', fontSize: '14px', lineHeight: '1.6', margin: '0 0 24px', textAlign: 'center' },
    success: {
        color: '#2c5f2e', fontSize: '14px', lineHeight: '1.7', textAlign: 'center',
        background: '#eaf6ea', padding: '16px', borderRadius: '10px', margin: '0 0 20px',
    },
    error: {
        color: '#b3123b', fontSize: '13px', background: '#fdeaef',
        padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', textAlign: 'center',
    },
    label: { display: 'block', color: '#4a3540', fontSize: '13px', fontWeight: '600', marginBottom: '6px' },
    inputWrap: { position: 'relative', marginBottom: '18px' },
    inputIcon: { position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', color: '#c0306a', fontSize: '14px' },
    input: {
        width: '100%', padding: '12px 40px 12px 40px', border: '1.5px solid #f0d9e5',
        borderRadius: '10px', fontSize: '14px', boxSizing: 'border-box', outline: 'none',
    },
    eye: { position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', color: '#c0306a', cursor: 'pointer', fontSize: '14px' },
    button: {
        width: '100%', padding: '13px', background: '#781840', color: '#fff', border: 'none',
        borderRadius: '10px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', marginTop: '4px',
    },
    backLink: { textAlign: 'center', marginTop: '22px', marginBottom: 0 },
    link: { color: '#c0306a', fontSize: '13px', textDecoration: 'none', fontWeight: '600' },
};

export default ReinitialiserMotDePasse;